import { Injectable } from "@angular/core";
import { AppConfig } from "../app.config";

@Injectable({ providedIn: 'root' })
export class LoggingService
{  
    constructor(public appConfig:AppConfig) {}

    public log(...args: any[]) {
        if (this.appConfig.isProd) {
            return;
        }

        const timestamp = new Date().toISOString();
        console.log(`[${timestamp}]`, ...args);
    }
}
